import {Mapper} from '@s-ui/domain'

export class SeoAdsListSemanticYearMetaConfigMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.config
   * @param {Object} deps.log
   * */
  constructor({config}) {
    super()
    this._config = config
    this._seoConfig = this._config.get('seo')
  }

  _getAdsListSemanticConfigKey = ({make, year}) => {
    const hasMake = Boolean(make)
    const hasYear = Boolean(year)

    // This is the unique combination of SEO Metadata typology
    // for year ads-list pages [/2017/]
    const isDefault = hasMake && hasYear

    if (isDefault) return 'default'
  }

  map = ({adsListSemanticConfig, params: {make, year}}) => {
    const adsListSemanticConfigKey = this._getAdsListSemanticConfigKey({
      make,
      year
    })

    return adsListSemanticConfig[adsListSemanticConfigKey]
  }
}
